const accessTokenKey = 'token'
const refreshToeknKey = 'refresh-token'

export const getToken = (): string => {
  return localStorage.getItem(accessTokenKey) || ''
}

export const getRefreshToken = (): string => {
  return localStorage.getItem(refreshToeknKey) || ''
}

export const setToken = (token: string) => {
  localStorage.setItem(accessTokenKey, token)
}

export const setRefreshToken = (token: string) => {
  localStorage.setItem(refreshToeknKey, token)
}

export const clearToken = () => {
  localStorage.removeItem(accessTokenKey)
  localStorage.removeItem(refreshToeknKey)
}
